<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Leaves</span>
      <h1 class="hris-page-title">My Leave Applications</h1>
      <p class="hris-page-subtitle">View and manage your leave requests.</p>
    </div>

    <template v-if="is_pto_enabled">
      <div class="hris-panel">
        <div class="hris-form-section-title">Leave Applications</div>
        <q-table flat :data="combinedPaidLeaves" :columns="ResultColumns" :pagination.sync="unifiedPagination" row-key="id" dense>
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails(props.row.type, props.row.id)">
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No applications yet</div>
          </template>
        </q-table>
      </div>
    </template>

    <template v-else>
      <div class="hris-panel">
        <div class="hris-form-section-title">Emergency Leave</div>
        <q-table flat :data="elAppResultData" :columns="ResultColumns" :pagination.sync="elPagination" row-key="id" dense>
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('elApp',props.row.id)">
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No applications yet</div>
          </template>
        </q-table>
      </div>
      <div class="hris-panel">
        <div class="hris-form-section-title">Vacation Leave</div>
        <q-table flat :data="vlAppResultData" :columns="ResultColumns" :pagination.sync="vlPagination" row-key="id" dense>
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('vlApp',props.row.id)">
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No applications yet</div>
          </template>
        </q-table>
      </div>
      <div class="hris-panel">
        <div class="hris-form-section-title">Sick Leave</div>
        <q-table flat :data="slAppResultData" :columns="ResultColumns" :pagination.sync="slPagination" row-key="id" dense>
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('slApp',props.row.id)">
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No applications yet</div>
          </template>
        </q-table>
      </div>
    </template>

    <div class="hris-panel">
      <div class="hris-form-section-title">Maternity Leave</div>
      <q-table flat :data="mlAppResultData" :columns="ResultColumns" :pagination.sync="mlPagination" row-key="id" dense>
        <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('mlApp',props.row.id)">
          <q-td key="status" :props="props">{{ props.row.status }}</q-td>
          <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
          <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="department" :props="props">{{ props.row.department }}</q-td>
        </q-tr>
        <template v-slot:no-data>
          <div class="hris-empty full-width">No applications yet</div>
        </template>
      </q-table>
    </div>
    <div class="hris-panel">
      <div class="hris-form-section-title">Paternity Leave</div>
      <q-table flat :data="plAppResultData" :columns="ResultColumns" :pagination.sync="plPagination" row-key="id" dense>
        <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('plApp',props.row.id)">
          <q-td key="status" :props="props">{{ props.row.status }}</q-td>
          <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
          <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="department" :props="props">{{ props.row.department }}</q-td>
        </q-tr>
        <template v-slot:no-data>
          <div class="hris-empty full-width">No applications yet</div>
        </template>
      </q-table>
    </div>
    <div class="hris-panel">
      <div class="hris-form-section-title">Magna Carta Leave</div>
      <q-table flat :data="mcAppResultData" :columns="ResultColumns" :pagination.sync="mcPagination" row-key="id" dense>
        <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('mcApp',props.row.id)">
          <q-td key="status" :props="props">{{ props.row.status }}</q-td>
          <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
          <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="department" :props="props">{{ props.row.department }}</q-td>
        </q-tr>
        <template v-slot:no-data>
          <div class="hris-empty full-width">No applications yet</div>
        </template>
      </q-table>
    </div>
    <div class="hris-panel">
      <div class="hris-form-section-title">Solo Parent Leave</div>
      <q-table flat :data="spAppResultData" :columns="ResultColumns" :pagination.sync="spPagination" row-key="id" dense>
        <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('spApp',props.row.id)">
          <q-td key="status" :props="props">{{ props.row.status }}</q-td>
          <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
          <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="department" :props="props">{{ props.row.department }}</q-td>
        </q-tr>
        <template v-slot:no-data>
          <div class="hris-empty full-width">No applications yet</div>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="loadingModel" persistent>
      <div class="hris-loading" style="background: transparent; min-width: 200px;">
        <q-spinner color="green" size="3em" />
        <div>{{ loadingText }}</div>
      </div>
    </q-dialog>

    <q-dialog v-model="leaveDetailsDialog" persistent transition-show="scale" transition-hide="scale">
      <div class="hris-modal hris-modal-lg">
        <div class="hris-modal-header">
          <div>
            <h2 class="hris-modal-title">Leave Application Details</h2>
            <p class="hris-modal-subtitle">Leave Type: {{ leaveType }}</p>
          </div>
          <q-btn flat dense round v-close-popup aria-label="Close">
            <i class="fas fa-times"></i>
          </q-btn>
        </div>
        <div class="hris-modal-body">
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.status" label="Status" outlined readonly stack-label dense color="green" />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.employee_name" label="Employee Name" outlined readonly stack-label dense color="green" />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.employee_department" label="Department" outlined readonly stack-label dense color="green" />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.date_applied" label="Date Applied" outlined readonly stack-label dense color="green" />
            </div>
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.total_days" label="Total Days" outlined readonly stack-label dense color="green" />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.date_start" label="Date Start" outlined readonly stack-label dense color="green" />
            </div>
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.date_end" label="Date End" outlined readonly stack-label dense color="green" />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.reason" label="Reason" type="textarea" outlined readonly stack-label dense color="green" />
            </div>
          </div>
          <template v-if="viewLeaveDetails.status != 'Pending'">
            <div class="hris-form-row">
              <div class="hris-form-field">
                <q-input :value="viewLeaveDetails.approver" label="Processed By" outlined readonly stack-label dense color="green" />
              </div>
              <div class="hris-form-field">
                <q-input :value="viewLeaveDetails.date_processed" label="Date Processed" outlined readonly stack-label dense color="green" />
              </div>
            </div>
            <div class="hris-form-row">
              <div class="hris-form-field" style="flex-basis: 100%;">
                <q-input :value="viewLeaveDetails.approver_remarks" label="Remarks" type="textarea" outlined readonly stack-label dense color="green" />
              </div>
            </div>
          </template>
        </div>
        <div class="hris-modal-footer">
          <q-btn v-if="viewLeaveDetails.status == 'Pending'" unelevated class="hris-q-outline" @click="confirmCancelApplication" label="Cancel Application" no-caps />
          <q-btn unelevated class="hris-q-primary" label="Close" v-close-popup no-caps />
        </div>
      </div>
    </q-dialog>

    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { date } from 'quasar';
export default {
  name: 'MyApplications_Leave',
  data() {
    return {
      is_pto_enabled: false,
      loadingModel: false,
      loadingText: '',
      leaveDetailsDialog: false,
      leaveType: '',
      viewLeaveDetails: {},
      applications: {},
      elAppResultData: [],
      vlAppResultData: [],
      slAppResultData: [],
      mlAppResultData: [],
      plAppResultData: [],
      mcAppResultData: [],
      spAppResultData: [],
      elPagination: { rowsPerPage: 5 },
      vlPagination: { rowsPerPage: 5 },
      slPagination: { rowsPerPage: 5 },
      mlPagination: { rowsPerPage: 5 },
      plPagination: { rowsPerPage: 5 },
      mcPagination: { rowsPerPage: 5 },
      spPagination: { rowsPerPage: 5 },
      unifiedPagination: { rowsPerPage: 10 },
      ResultColumns: [
        { name: 'status', field: 'status', label: 'Status', align: 'center' },
        { name: 'date_applied', field: 'date_applied', label: 'Date Applied', align: 'center' },
        { name: 'inclusive_dates', field: 'inclusive_dates', label: 'Inclusive Dates', align: 'center' },
        { name: 'name', field: 'name', label: 'Name', align: 'center' },
        { name: 'department', field: 'department', label: 'Department', align: 'center' }
      ]
    }
  },
  computed: {
    hasUnifiedLeaveFeature: function() {
      return (this.userData.features || []).includes('pto');
    },
    combinedPaidLeaves: function() {
      return [...this.elAppResultData.map(d => ({...d, type: 'elApp'})), 
              ...this.vlAppResultData.map(d => ({...d, type: 'vlApp'})), 
              ...this.slAppResultData.map(d => ({...d, type: 'slApp'}))];
    }
  },
  methods: {
    loadStatus: function() {
      this.is_pto_enabled = this.hasUnifiedLeaveFeature;
    },
    loadApplications: function() {
      this.loadingModel = true;
      this.loadingText = 'Retrieving Applications';
      axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        })
        .get('/leave/applications/retrieve', {
          params: { id: this.userData.id }
        })
        .then((res) => {
          this.applications = res.data.data;
          Object.keys(this.applications).forEach((key) => {
            let appKey = key + "ResultData";
            this[appKey] = [];
            for (let eachApp of this.applications[key]) {
              let tempDate = date.extractDate(eachApp.date_applied, 'YYYY-MM-DD HH:mm:ss');
              let date_applied = date.formatDate(tempDate, 'MMMM DD, YYYY');
              let tempIncDate = eachApp.inclusive_dates.split('/');
              let finalIncDate = '';
              if (tempIncDate[0] == tempIncDate[1]) {
                finalIncDate = date.formatDate(tempIncDate[0], 'MMMM DD, YYYY');
              } else {
                finalIncDate = date.formatDate(tempIncDate[0], 'MMMM DD') + ' - ' + date.formatDate(tempIncDate[1], 'DD, YYYY');
              }

              this[appKey].push({
                id: eachApp.id,
                status: eachApp.status,
                date_applied: date_applied,
                inclusive_dates: finalIncDate,
                name: eachApp.name,
                department: eachApp.department
              });
            }
          });
        })
        .finally(() => {
          this.loadingModel = false;
        })
    },
    viewDetails: function(leaveApp, rowID) {
      this.loadingModel = true;
      this.loadingText = 'Retrieving Details';
      axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        })
        .get('/leave/applications/details', {
          params: { id: rowID, type: leaveApp }
        })
        .then((res) => {
          this.loadingModel = false;
          this.viewLeaveDetails = res.data.data;
          this.leaveDetailsDialog = true;
          
          let d = date.extractDate(this.viewLeaveDetails.date_applied, 'YYYY-MM-DD HH:mm:ss');
          this.viewLeaveDetails.date_applied = date.formatDate(d, 'MMMM DD, YYYY @ hh:mmA');
          this.viewLeaveDetails.date_start = date.formatDate(this.viewLeaveDetails.date_start, 'MMMM DD, YYYY');
          this.viewLeaveDetails.date_end = date.formatDate(this.viewLeaveDetails.date_end, 'MMMM DD, YYYY');
          
          if (this.viewLeaveDetails.status != 'Pending') {
            let dp = date.extractDate(this.viewLeaveDetails.date_processed, 'YYYY-MM-DD HH:mm:ss');
            this.viewLeaveDetails.date_processed = date.formatDate(dp, 'MMMM DD, YYYY @ hh:mmA');
          }

          const types = {
            'elApp': 'Emergency Leave',
            'vlApp': 'Vacation Leave',
            'slApp': 'Sick Leave',
            'mlApp': 'Maternity Leave',
            'plApp': 'Paternity Leave',
            'mcApp': 'Magna Carta Leave',
            'spApp': 'Solo Parent Leave'
          };
          this.leaveType = types[leaveApp] || 'Unknown';
        });
    },
    confirmCancelApplication: function() {
        this.$q.dialog({
            title: 'Confirm Cancellation',
            message: 'Are you sure you want to cancel this application?',
            cancel: true,
            persistent: true
        }).onOk(() => {
            this.cancelApplication();
        });
    },
    cancelApplication: function() {
        axios.create({
            baseURL: this.apiUrl,
            headers: { 'Authorization': `Bearer ${this.token}` }
        }).post('/leave/applications/cancellation', {
            form_data: JSON.stringify({ appID: this.viewLeaveDetails.id })
        }).then(() => {
            this.leaveDetailsDialog = false;
            this.loadApplications();
            this.$q.notify({ color: 'green-7', message: 'Application Cancelled' });
        });
    }
  },
  mounted() {
    this.loadStatus();
    this.loadApplications();
  }
}
</script>
<style lang="css" scoped>
</style>
